import { BaseDto } from "@models/base/baseDto.model";
import { DtoBase } from "@models/base/dtoBase.model";
import { LocalidadDto } from "@models/localidad/localidadDto.model";
import { PaisDto } from "@models/pais/paisDto.model";

export class JuzgadoDto extends BaseDto {
  nombre!: string;
  domicilio!: string;
  telefono!: string;
  correo!: string;
  region!: string;
  localidad!: LocalidadDto;
  idLocalidad!:number
  pais!: PaisDto;
  jurisdiccion!: DtoBase;
  fuero!: DtoBase;
  nominacion!: string;
  subnominacion!: string;
  competencia!: string;
  grado!: string;
  numero!: string;
  letra!: string;
  esActivo: boolean = false;
  esSecretaria: boolean = false;
  tieneMesaVirtual: boolean = false;
  horarioAtencion!: string;
  urlSistemaGestion!: string;
}
